module.exports = __webpack_public_path__ + "img/paper-plane.50d39be2.png";